import {loginRequest} from '@/helpers/authConfig'
import {isSUT} from '@/utils/env'
import {InteractionStatus} from '@azure/msal-browser'
import {TokenClaims} from '@azure/msal-common'
import {useMsal} from '@azure/msal-react'
import {jwtDecode} from 'jwt-decode'
import {useCallback, useEffect, useState} from 'react'

export type ClaimsProps = TokenClaims & {
  firstName?: string
  lastName?: string
  accessRules?: string
}

export type UserInfo = {
  firstName: string
  lastName: string
}

export const useAuth = () => {
  const {instance, accounts, inProgress} = useMsal()
  const [accessToken, setAccessToken] = useState<string | undefined>()
  const [userInfo, setUserInfo] = useState<UserInfo>({firstName: '', lastName: ''})
  // const isCypress = localStorage.getItem('cypress-test') == '1'
  const isCypress = isSUT()
  const fetchToken = useCallback(async () => {
    try {
      const response = await instance.acquireTokenSilent({
        ...loginRequest,
        account: accounts[0],
      })
      const decode = jwtDecode<{family_name?: string; given_name?: string}>(response?.accessToken)
      setUserInfo({
        firstName: decode?.family_name || '',
        lastName: decode?.given_name || '',
      })

      setAccessToken(response.accessToken)
      localStorage.setItem('msalAccessToken', response.idToken) //here idToken is used to authenticate APIs
    } catch (error) {
      const typedError = error as {errorCode: string}
      if (['interaction_required', 'invalid_grant', 'no_tokens_found'].includes(typedError.errorCode) && !isCypress) {
        // Token is expired or interaction is required, prompt user to login again const isCypress = localStorage.getItem('cypress-test') == '1'

        instance.loginRedirect(loginRequest)
      } else {
        console.error('Error fetching token:', error)
      }
    }
  }, [accounts, instance, isCypress])

  const signInWithRedirect = () => {
    if (!isCypress) {
      instance.loginRedirect(loginRequest)
    }
  }

  const signOut = () => {
    localStorage.removeItem('msalAccessToken')
    instance.logoutRedirect({
      // postLogoutRedirectUri: `${window.location.origin}/login`,
    })
  }

  const handleLogin = (loginType: string) => {
    if (inProgress === InteractionStatus.None && !isCypress) {
      if (loginType === 'popup') {
        instance.loginPopup(loginRequest).catch(e => {
          console.log(e)
        })
      } else if (loginType === 'redirect') {
        instance.loginRedirect(loginRequest).catch(e => {
          console.log(e)
        })
      }
    }
  }

  useEffect(() => {
    if (accounts.length > 0) fetchToken()
  }, [accounts, fetchToken])

  return {
    authState: inProgress,
    instance,
    accessToken,
    handleLogin,
    signInWithRedirect,
    signOut,
    fetchToken,
    account: accounts[0],
    isAuthenticated: accessToken !== undefined,
    claims: (accounts[0]?.idTokenClaims || {}) as ClaimsProps,
    isCypress,
    inProgress,
    userInfo,
  }
}
